export default __webpack_public_path__ + "static/media/logo.61d1273d.svg";